import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { LOCAL_STORAGE } from 'app/commons/constants'
import { crossStorageUtils } from 'app/commons/helpers/crossStorage'
import i18n from 'app/i18n'

import { initAuth } from '../../interface/IAuth'
import { editProfile, handleCheckVerificationCode, handleGetAuth, handleGetWallet, postSignIn } from './authAction'

const authSlice = createSlice({
  name: 'auth',
  initialState: initAuth,
  reducers: {
    clearErrorMessage: (state) => {
      state.errorCurrentPassword = ''
    },
    updateCustomer: (state, action: PayloadAction<any>) => {
      state.login.accounts = { ...state.login.accounts, ...action.payload }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(editProfile.fulfilled, (state, action: PayloadAction<any>) => {
      const { login } = action.payload
      state.login.accounts = { ...state.login.accounts, ...login }
    })
    builder.addCase(editProfile.rejected, (state, action: PayloadAction<any>) => {
      state.errorCurrentPassword =
        action.payload.error === 'Old password is incorrect' ? i18n.t('common.dlvrApiError.changePwdFail') : ''
    })
    builder.addCase(postSignIn.fulfilled, (state, action: PayloadAction<any>) => {
      const { object, access_token } = action.payload
      localStorage.setItem(LOCAL_STORAGE.ACCOUNT_INFO, JSON.stringify(object))
      if (!access_token) return state
      state.login = {
        accounts: { ...state.login.accounts, ...object },
        access_token,
      }
      state.isLogged = true
    })
    builder.addCase(handleCheckVerificationCode.fulfilled, () => {
      // state.login.accounts.sms_confirmed_at = true;
    })
    builder.addCase(handleGetAuth.fulfilled, (state, action: PayloadAction<any>) => {
      if (!action.payload) return
      const { accounts, access_token, customerFtlConfig } = action.payload
      state.login.accounts = { ...state.login.accounts, ...accounts }
      state.login.access_token = access_token
      state.customerFtlConfig = customerFtlConfig
      state.isLogged = true
    })
    builder.addCase(handleGetAuth.rejected, () => {
      crossStorageUtils.setAccessToken('')
    })
    builder.addCase(handleGetWallet.fulfilled, (state, action: PayloadAction<any>) => {
      state.currentCredits = action.payload?.amount
    })
  },
})

export const authCreateActions = authSlice.actions
export default authSlice
